import { cx } from "@app/shared/utils/cx";
import styles from "./Skeleton.module.css";

export type SkeletonProps = {
  width?: string | number;
  height?: string | number;
  radius?: string;
  className?: string;
};

export const Skeleton = ({ width = "100%", height = 16, radius, className }: SkeletonProps) => (
  <span
    className={cx(styles.skeleton, className)}
    style={{ width, height, borderRadius: radius }}
    aria-hidden="true"
  />
);
